import { gql } from 'urql';

export const ModSignup = gql`
  fragment ModSignup on ModSignup {
    id
    createdAt
    eventAttendee {
      id
      user {
        id
        fullName
      }
    }
    character {
      id
      name
    }
  }
`;
